import React from 'react';
import FileSaver from 'file-saver';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import  { useState, useEffect } from 'react';
import { fabric } from "fabric";
import '../Components/Canvas.css';
import{ /*Alert,*/ 
      Button, 
      DropdownButton, 
      Dropdown, 
      ButtonGroup, 
      Navbar,
      Nav,
      NavDropdown,
      Form,
      Modal
    } from 'react-bootstrap';
import { text } from 'dom-helpers';

const SHAPES = {
  left: 'Left foot',
  right: 'Right foot',
  both: 'Both feet'
}




const grid = 137.5

function Canvas () {
    const [canvas, setCanvas] = useState('');
    const [name, setName] = useState('');
    const [value, setValue] = useState("#000000");
    const [activeShape, setActiveShape] = useState('left');
    const [activeBeat, setActiveBeat] = useState(1);
    const [currentStep, setCurrentStep] = useState(null);
    // for the modal
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [beats, setBeats] = useState({
      1:[],
      2:[],
      3:[],
      4:[],
      5:[],
      6:[],
      7:[],
      8:[],
    });
    const [boundingBoxes, setBoundingBoxes] = useState([]);

  useEffect(() => {
    const newCanvas = new fabric.Canvas('canvas', {
      height: 400,
      width: 1100,
      strokeWidth: 3,
      backgroundColor: 'white',
      lockMovementX: true,
      lockMovementY: true,
      stroke: 'white'
    });

    const boxes = Object.keys(beats).map(beat => {
      const left = grid* (Number(beat) - 1);

      return new fabric.Rect({
        fill: 'transparent',
        width: grid,
        height: 399,
        hasBorders: false,
        hasControls: false,
        lockMovementX: true,
        lockMovementY: true,
        selectable: false,
        stroke: 'black',
        strokeWidth: 1,
        left,
        hoverCursor: 'pointer'
      });
    })
    boxes.forEach(box => newCanvas.add(box))
    setBoundingBoxes(boxes)

    setCanvas(newCanvas)
  }, [])


  

  const drawArrow = () => {
   new fabric.Path('M32,16.009c0-0.267-0.11-0.522-0.293-0.714  l-9.899-9.999c-0.391-0.395-1.024-0.394-1.414,0c-0.391,0.394-0.391,1.034,0,1.428l8.193,8.275H1c-0.552,0-1,0.452-1,1.01  s0.448,1.01,1,1.01h27.586l-8.192,8.275c-0.391,0.394-0.39,1.034,0,1.428c0.391,0.394,1.024,0.394,1.414,0l9.899-9.999  C31.894,16.534,31.997,16.274,32,16.009z')

  }
  
  

 const addNewShape = () => {
   const idx = Number(activeBeat)-1
  const left = grid* idx;
  const boundingBox = boundingBoxes[idx]
  
  let svg;
  switch(activeShape) {
    case 'left':
      svg = new fabric.Path('M28.7,54.8c20-64.4-38.2-80-25.5-0.7C11.6,54.7,19.3,54.4,28.7,54.8z\M29.9,66.9c-7.8,0.6-16.4,1.3-24.5,0.8C5.7,107.3,35.7,104.5,29.9,66.9z', { stroke: 'black', fill:'transparent'}); //'https://svgshare.com/i/_WV.svg'
      break;
    case 'right':
      svg = new fabric.Path('M46.8,53.6c-23-70.7,39.1-71.5,25.6,1.2\M46.8,53.6c8.4,1.1,17.1,0.7,25.6,1.2\M45.3,66c8.2,0.6,16.3,1.9,24.5,2.8\M45.3,66c-6.7,35.3,23.4,41.3,24.5,2.8', { stroke: 'black', fill:'transparent'}); //'https://svgshare.com/i/_Wd.svg';
      break;
    case 'both':
    default:
      svg = new fabric.Path('M28.7,54.8c20-64.4-38.2-80-25.5-0.7C11.6,54.7,19.3,54.4,28.7,54.8z\M29.9,66.9c-7.8,0.6-16.4,1.3-24.5,0.8C5.7,107.3,35.7,104.5,29.9,66.9z\M46.8,53.6c-23-70.7,39.1-71.5,25.6,1.2\M46.8,53.6c8.4,1.1,17.1,0.7,25.6,1.2\M45.3,66c8.2,0.6,16.3,1.9,24.5,2.8\M45.3,66c-6.7,35.3,23.4,41.3,24.5,2.8', { stroke: 'black', fill:'transparent'});//'https://svgshare.com/i/_Vt.svg';
      break;
  }

  new fabric.Path('M32,16.009c0-0.267-0.11-0.522-0.293-0.714  l-9.899-9.999c-0.391-0.395-1.024-0.394-1.414,0c-0.391,0.394-0.391,1.034,0,1.428l8.193,8.275H1c-0.552,0-1,0.452-1,1.01  s0.448,1.01,1,1.01h27.586l-8.192,8.275c-0.391,0.394-0.39,1.034,0,1.428c0.391,0.394,1.024,0.394,1.414,0l9.899-9.999  C31.894,16.534,31.997,16.274,32,16.009z')


  // fabric.loadSVGFromURL(svg, (objects) => {
    // const loadedObject = fabric.util.groupSVGElements(objects);
    const loadedObject = svg;
    loadedObject.set('left', left) 
    setCurrentStep(loadedObject);

    canvas.on("object:moving", function() {
      const left = loadedObject.left;    
      const leftBound = boundingBox.left;
      const rightBound = leftBound + boundingBox.width;
    
      loadedObject.set('left',(Math.min(Math.max(left, leftBound), rightBound - loadedObject.width)));  
      setCurrentStep(loadedObject);
    });
    
    const hasShape = beats[activeBeat].find(item => item === activeShape)
    if(activeShape) {

    }

    const shouldNotAdd = beats[activeBeat].find(item => item === 'both') || (activeShape === 'both' && beats[activeBeat].length>0)
    if(shouldNotAdd) {
      alert(`${SHAPES[activeShape]} cannot be added to beat ${activeBeat}. Please try a different one.`)
      return
    }
    if(hasShape) alert(`Beat ${activeBeat} already has a ${SHAPES[activeShape].toLowerCase()}. Please try a different one.`);
    else {
      const newBeats = {...beats};
      newBeats[activeBeat].push(activeShape);
      setBeats(newBeats)

      canvas.add(loadedObject);
      canvas.setActiveObject(loadedObject);
      canvas.renderAll();
    }
  
}

const onChange = (event) => { 
  setValue(event.target.value)
};

var isRedoing = false;
var h = [];

const undo = canvi => {
  canvi.on('object:added',function(){
    if(!isRedoing){
      h = [];
    }
    isRedoing = false;
  }) 
  if(canvi._objects.length>0){
   h.push(canvi._objects.pop());
   canvi.renderAll();
  }
};

const redo = canvi => { // redo function
  
  if(h.length > 0){
    isRedoing = true;
   canvi.add(h.pop());
  }
};

const onTestSaveFile = () => {
  var blob = new Blob([canvas], {type: "jpg"});
  FileSaver.saveAs(blob, "My Steps.jpg");
};



const addText = canvi => { // function that adds text to the canvas
  const text = new fabric.IText('Sample Text', {
    left: canvi.width / 2,
    top: canvi.height / 2,
    fill: 'black',
    fontFamily: 'sans-serif',
    hasRotatingPoint: false,
    centerTransform: true,
    originX: 'center',
    originY: 'center',
    lockUniScaling: true
  });
  canvi.add(text);
  }
  

  const updateColor = () => {
    // if(currentStep)
      // color = value;
      canvas.getActiveObject().set('fill',value);
      canvas.renderAll();
    // }
  }

  const onChangeName = (event) => {
    try{
    setName(event.target.value)
    } catch(e){
      console.log(e)
    }
    // setName(event.target.value)
  }

  const getStatus = (idx = 0) => {
    try {
    const hasBoth = beats[idx].find(item => item === 'both')
    const hasRight = beats[idx].find(item => item === 'right')
    const hasLeft = beats[idx].find(item => item === 'left')

    if(hasBoth || (hasRight && hasLeft)) {
      return 'Possibly Complete'
    }

    return 'Incomplete'
  } catch(e) {
    return ''
  }
  }


  function saveCanvas (canvi){
  var image = canvi.toDataURL("image/jpg", 1.0).replace("image/jpg", "image/octet-stream");
  var link = document.createElement('a');
  link.download = "my-image.jpg";
  link.href = image;
  link.click(); 
  }

  function undoBeat (cnvas){
    cnvas.remove(cnvas.getActiveObject())
  };



  return(
      

<> 

    
  <Navbar style={{ paddingLeft: 40 ,backgroundColor: '#606B6E'}}>
   
    <Navbar.Brand href="/" style={{fontWeight: 550, color: '#8aa2a9'}}>SALSAEditor</Navbar.Brand>
    <Nav className="me-auto" >
      <Nav.Link onClick={()=>undo(canvas)} style={{ color:'black'}} >Undo</Nav.Link>
      <Nav.Link  onClick={()=>redo(canvas)}  style={{ color:'black' }} >Redo</Nav.Link>
      <Nav.Link onClick={() => addText(canvas)}style={{ color:'black' }} >Text</Nav.Link>
      <NavDropdown variant="dark" title="Shapes" id="collasible-nav-dropdown" style={{ color:'black'}}>
        <NavDropdown.Item onClick={ () => drawArrow()} style={{ color:'black' }}>Arrow</NavDropdown.Item>
        <NavDropdown.Item style={{ color:'black' }}>Curve Arrow</NavDropdown.Item>
        
      </NavDropdown>
      <Nav.Link onClick={() => saveCanvas(canvas)} style={{ color:'black'}} download >Export</Nav.Link>
    
      <Form.Label  htmlFor="exampleColorInput" style={{ backgroundColor: '#63575E'}}></Form.Label>
      <Form.Control
        type="color"
        id="color"
        defaultValue={value}
        title="Choose your color"
        onChange={onChange}
      />
      <Nav.Link onClick={updateColor} style={{ color:'black', borderRadius: 5}}  >Change Color</Nav.Link>
    </Nav>
   </Navbar> 
    <div style={{ backgroundColor: '#E7E7E7', display: 'flex'}}> 
    <div className="container" style={{ backgroundColor: '#E7E7E7', flex: 1, height: '77vh', width: '900'}}>
            <>
              {/* <Button style={{ backgroundColor: activeBeat !==1 ? "#AFBC88" : "#618B4A",  strokeColor: 'black'}} onClick={() => setActiveBeat(1)}>Beat 1</Button>{"      "}
              <Button style={{ backgroundColor: activeBeat !==2? "#AFBC88" : "#618B4A",   stroke: 'black'}} onClick={() => setActiveBeat(2)}>Beat 2</Button>{"      "}
              <Button style={{ backgroundColor: activeBeat !==3 ? "#AFBC88" : "#618B4A",  stroke: 'black' }}onClick={() => setActiveBeat(3)}>Beat 3</Button>{"      "}
              <Button style={{ backgroundColor: activeBeat !==4 ? "#AFBC88" : "#618B4A",  stroke: 'black' }} onClick={() => setActiveBeat(4)}>Beat 4</Button>{"      "}
              <Button style={{ backgroundColor: activeBeat !==5 ? "#AFBC88" : "#618B4A",  stroke: 'black' }} onClick={() => setActiveBeat(5)}>Beat 5</Button>{"      "}
              <Button style={{ backgroundColor: activeBeat !==6 ? "#AFBC88" : "#618B4A",  stroke: 'black' }} onClick={() => setActiveBeat(6)}>Beat 6</Button>{"      "}
              <Button style={{ backgroundColor: activeBeat !==7 ? "#AFBC88" : "#618B4A",  stroke: 'black' }} onClick= {() => setActiveBeat(7)}>Beat 7</Button>{"      "}
              <Button style={{ backgroundColor: activeBeat !==8 ? "#AFBC88" : "#618B4A",  stroke: 'black' }} onClick={() => setActiveBeat(8)}>Beat 8</Button>{"      "} */}
              <Button variant="secondary" style={{ borderRadius: 10}} onClick={() => setActiveBeat(1)}>Beat 1</Button>{"      "}
              <Button variant="secondary" style={{ borderRadius: 10}} onClick={() => setActiveBeat(2)}>Beat 2</Button>{"      "}
              <Button variant="secondary" style={{ borderRadius: 10}} onClick={() => setActiveBeat(3)}>Beat 3</Button>{"      "}
              <Button variant="secondary" style={{ borderRadius: 10}} onClick={() => setActiveBeat(4)}>Beat 4</Button>{"      "}
              <Button variant="secondary" style={{ borderRadius: 10}} onClick={() => setActiveBeat(5)}>Beat 5</Button>{"      "}
              <Button variant="secondary" style={{ borderRadius: 10}} onClick={() => setActiveBeat(6)}>Beat 6</Button>{"      "}
              <Button variant="secondary" style={{ borderRadius: 10}} onClick= {() => setActiveBeat(7)}>Beat 7</Button>{"      "}
              <Button variant="secondary" style={{ borderRadius: 10}} onClick={() => setActiveBeat(8)}>Beat 8</Button>{"      "}
              <DropdownButton variant="secondary" style={{borderRadius: 15, backgroundColor: "#AFBC88"}} as={ButtonGroup}  title={SHAPES[activeShape]} >
                <Dropdown.Item onClick={()=>setActiveShape('left')}> Left Foot</Dropdown.Item>
                <Dropdown.Item onClick={() => setActiveShape('right')}>Right Foot</Dropdown.Item>
                <Dropdown.Item onClick={() => setActiveShape('both')}>2 Feet</Dropdown.Item>
              </DropdownButton>
            </> 
             {' '}
             &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;
            <Button variant="secondary" style={{ borderRadius: 10}} onClick={() => addNewShape(canvas, setActiveShape, setActiveBeat)}>Add new step</Button> {' '}
            <Button variant="secondary" onClick={handleShow} style={{ borderRadius: 10}}> Save </Button> 
            {/* <Button style={{borderColor: 'black', backgroundColor:'#FFD9CE', color: 'black', borderRadius: 10}} onClick={() => undoBeat(canvas)}>Add new step</Button> */}
            
            
            
            <>
            
             {/* <a href="" title="Go to W3Schools HTML section">Save</a> */}
                  <br/> <br/>
              <Modal show={show} onHide={handleClose}>
                  <Modal.Header >
                    <Modal.Title>Save</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Name</Form.Label>
                    <Form.Control  value={name} type="text" placeholder="Name" onChange={onChangeName}/>
                    <Form.Text className="text-muted">
                     Name you diagram as desired.
                    </Form.Text>
                    </Form.Group> 

                  </Modal.Body>
                  <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose}>
                    Close
                  </Button>
                </Modal.Footer>
            </Modal>
            </>
            <div style={{width: 1100}}>

           <p>Name: {name}</p>
           <div style={{flexDirection: 'row', display: 'flex'}}>
           <ButtonGroup style={{justifyContent: 'space-between'}}>
             <Button variant="secondary"  style={{borderRadius: 10, marginRight: 35, textDecoration: 'none', marginLeft: 10, fontSize: 'small'}}>{getStatus(0)}Incomplete</Button>
             <Button variant="secondary"  style={{ borderRadius: 10, marginRight: 55, textDecoration: 'none', marginLeft: 10, fontSize: 'small'}}>{getStatus(1)}</Button>
             <Button variant="secondary"  style={{borderRadius: 10, marginRight: 50, textDecoration: 'none', fontSize: 'small'}}>{getStatus(2)}</Button>
             <Button variant="secondary"  style={{borderRadius: 10, marginRight: 50, textDecoration: 'none', fontSize: 'small'}}>{getStatus(3)}</Button>
             <Button variant="secondary"  style={{borderRadius: 10, marginRight: 50, textDecoration: 'none', fontSize: 'small' }}>{getStatus(4)}</Button>
             <Button variant="secondary"  style={{borderRadius: 10, marginRight: 50, textDecoration: 'none', fontSize: 'small' }}>{getStatus(5)}</Button>
             <Button variant="secondary"  style={{borderRadius: 10, marginRight: 50, textDecoration: 'none', fontSize: 'small' }}>{getStatus(6)}</Button>
             <Button variant="secondary"  style={{borderRadius: 10, marginRight: 50, textDecoration: 'none', fontSize: 'small' }}>{getStatus(7)}</Button> 
           </ButtonGroup> 
           </div> 
           &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <canvas style={{width: '100%'}} id="canvas" />
            </div>

        </div> 
     </div> 

   {/* <div class="containe-fluid">
<div class="container">
  <header>
    <div class="row flex-nowrap justify-content-between align-items-center">
      <div class="col-4 text-center">
        <a class="blog-header-logo text-dark text-decoration-none " href="#">SALSAEditor</a>
      </div>
      <div class="col-4 d-flex justify-content-end align-items-center">
        <a class="btn btn-sm btn-outline-secondary" href="#">About</a>
      </div>
    </div>
  </header>


  <div class="d-flex bd-highlight mb-3">
  <div class="p-2 bd-highlight">
  <a class="btn btn-sm btn-outline-secondary" href="#">Undo</a>
  </div>
  <div class="p-2 bd-highlight">
  <a class="btn btn-sm btn-outline-secondary" href="#">Redo</a>
  </div>
  <div class="p-2 bd-highlight">
  <a class="btn btn-sm btn-outline-secondary" href="#">Text</a>
  </div>
  <div class="p-2 bd-highlight">
  <a class="btn btn-sm btn-outline-secondary" href="#">Color</a>
  </div>
  <div class="ml-auto p-2 bd-highlight">
  <a class="btn btn-sm btn-outline-secondary" href="#">Save</a> &nbsp;&nbsp;&nbsp;&nbsp;
  <a class="btn btn-sm btn-outline-secondary" href="#">Help</a>
  </div>
  </div>

  <div class="d-flex bd-highlight mb-3">
  <div class="p-2 bd-highlight">
  <a class="btn btn-sm btn-outline-secondary" href="#">Beat 1</a>
  </div>
  <div class="p-2 bd-highlight">
  <a class="btn btn-sm btn-outline-secondary" href="#">Beat 2</a>
  </div>
  <div class="p-2 bd-highlight">
  <a class="btn btn-sm btn-outline-secondary" href="#">Beat 3</a>
  </div>
  <div class="p-2 bd-highlight">
  <a class="btn btn-sm btn-outline-secondary" href="#">Beat 4  </a>
  </div>
  <div class="p-2 bd-highlight">
  <a class="btn btn-sm btn-outline-secondary" href="#">Beat 5</a>
  </div>
  <div class="p-2 bd-highlight">
  <a class="btn btn-sm btn-outline-secondary" href="#">Beat 6</a>
  </div>
  <div class="p-2 bd-highlight">
  <a class="btn btn-sm btn-outline-secondary" href="#">Beat 7</a>
  </div>
  <div class="p-2 bd-highlight">
  <a class="btn btn-sm btn-outline-secondary" href="#">Beat 8</a>
  </div>
  <div class="ml-auto p-2 bd-highlight">
  <div class="dropdown">
  <a class="btn btn-sm btn-outline-secondary" href="#">Add New Step</a> &nbsp;&nbsp;&nbsp;&nbsp;
  <a class="btn btn-secondary dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
    Dropdown link
  </a>
  <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
    <a class="dropdown-item" href="#">Left Step</a>
    <a class="dropdown-item" href="#">Right Step</a>
    <a class="dropdown-item" href="#">Both Step</a>
  </div>
</div>
 
  </div>
</div>

</div> 



<main class="container">
  
    <canvas style={{width: '100%'}} id="canvas" />

</main> */}

{/* <footer class="blog-footer">
  <p>Blog template built for <a href="https://getbootstrap.com/">Bootstrap</a> by <a href="https://twitter.com/mdo">@mdo</a>.</p>
  <p>
    <a href="#">Back to top</a>
  </p>
</footer> */}


    
 {/* </div> */}

</>
  );

}

export default Canvas;